import { Component } from '@angular/core';
import { DataLoaderService } from '../expert-service-call.index';

@Component({
	selector: 'expert-success-message',
	templateUrl: './expert-success-message.template.html',
	styleUrls: ['./expert-success-message.component.css']
})

export class ExpertSuccessMessageComponent {
	public options: any;
	constructor(private dataLoaderService: DataLoaderService) {
	}
	ngOnInit() {
		if (this.dataLoaderService.data.vehInfo[0].model === 'SMRT' ) {
			this.options = "Color, Additional Color & Upholstery";
		}
		else {
			this.options = "Color & Upholstery";
		}
	}

	okButton() {
		this.dataLoaderService.flagDictionary.expertSummaryFlag = false;
	}
	
	ok(){
		this.dataLoaderService.flagDictionary.expertSummaryFlag = false;
		this.dataLoaderService.flagDictionary.expertSuccessFlag=false;
		this.dataLoaderService.flagDictionary.expertFlag=true;
	}

}





// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-success-message/expert-success-message.component.ts